import PageShell from "@/components/feature/PageShell";
import Hero from "./components/Hero";
import StatsSection from "./components/StatsSection";
import ServicesSection from "./components/ServicesSection";
import AHISPreview from "./components/AHISPreview";
import TechStackSection from "./components/TechStackSection";
import AboutSection from "./components/AboutSection";
import InfrastructureSection from "./components/InfrastructureSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import ContactSection from "./components/ContactSection";

export default function Home() {
  return (
    <PageShell>
      <Hero />
      <StatsSection />
      <ServicesSection />
      <AHISPreview />
      <TechStackSection />
      <AboutSection />
      <InfrastructureSection />
      <FAQSection />
      <CTASection />
      <ContactSection />
    </PageShell>
  );
}